module.exports = __webpack_public_path__ + "assets/img/tit1.bf9fe2b7.png";